import { useRef, useState, type FC } from "react";
import Tab from "../../components/general/Tabs/components/Tab";

import { cn } from "@babybjorn/ui";
import { useTranslation } from "gatsby-plugin-react-i18next";
import AddToCartButton from "../../components/AddToCartButton";
import ScrollableTabs from "../../components/general/ScrollableTabs";
import type { TabGroupTabsProps } from "../../components/general/Tabs/components/TabGroup/TabGroup";
import { useIsTablet } from "../../hooks/use-is-screensize";
import * as s from "./ProductStickyNav.module.scss";

type ProductStickyNavProps = {
	selectedTabId: string;
	price: string;
	setSelectedTabId: (id: string) => void;
	tabs: TabGroupTabsProps;
	addToCart?: () => Promise<void>;
	hidden?: boolean;
};

const ProductStickyNav: FC<ProductStickyNavProps> = ({
	tabs,
	price,
	setSelectedTabId,
	selectedTabId,
	addToCart,
	hidden = false,
}) => {
	const { t } = useTranslation();
	const wrapperRef = useRef<HTMLElement>(null);
	const tabRefs = useRef<unknown[]>([]);

	const [, setShouldScroll] = useState(false);

	const shouldScrollHandler = (newShouldScroll: boolean) => {
		setShouldScroll(newShouldScroll);
	};

	const isTablet = useIsTablet();

	return (
		<nav ref={wrapperRef} className={cn(s.wrapper, { [s.hidden]: hidden })}>
			{isTablet && (
				<ScrollableTabs
					onShouldScroll={shouldScrollHandler}
					ariaLabelScroll={t("Show more")}
				>
					{tabs.map((tab, index) => (
						<Tab
							ref={(el) => (tabRefs.current[index] = el)}
							key={`${tab.label}-${index}`}
							index={index}
							label={tab.label}
							onClick={() =>
								setSelectedTabId(typeof tab.id === "string" ? tab.id : "")
							}
							active={selectedTabId === tab.id}
							anchorTag
							href={tab.cta?.link}
						/>
					))}
				</ScrollableTabs>
			)}
			<div className={s.price}>
				<p>{price}</p>

				{addToCart && (
					<AddToCartButton
						label={t("Add to Cart")}
						onClick={addToCart}
						divClassContainer={s.classContainer}
						alwaysBig
					/>
				)}
			</div>
		</nav>
	);
};
export default ProductStickyNav;
